import React from "react";
import style from "./style.module.css";
import HeadLines from "../../CommonComponents/HeadLines";
import moment from "moment";
import MediaCoverageCard from "../../CommonComponents/MediaCoverageCard/MediaCoverageCard";
const NewsCard = ({ cardData }) => {
  const handleReadMore = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };
  return (
    <div className={style["news-style"]}>
      {cardData &&
        cardData.length > 0 &&
        cardData.map((obj) => {
          return (
            <div>
              <div className={style["card-style"]}>
                {obj.video_url && obj.media_type === 2 ? (
                  <iframe
                    style={{ width: "100%", height: "100%" }}
                    title="news"
                    loading="lazy"
                    src={obj.video_url}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                ) : obj.multimedia && obj.multimedia.file_name ? (
                  <img
                    class={style["news-img-style"]}
                    alt=""
                    src={obj.multimedia.file_name}
                  />
                ) : null}

                <div className={style["card-info"]}>
                  <div className={style["card-date"]}>
                    <HeadLines
                      className={
                        "font-size14 line-height16 font-weight400 letterSpacing0125 textColorWhite"
                      }
                      text={obj.date}
                    />
                  </div>
                  <div className={style["card-info-style"]}>
                    <HeadLines
                      className={`font-size16 line-height19 font-weight500 letterSpacing05 colorDark5 ${style["truncate2"]}`}
                      text={obj.title && obj.title.length && obj.title}
                    />
                    <HeadLines
                      className={`margin-top6 font-size14 line-height19 font-weight400 letterSpacing05 colorDark7 ${style["truncate"]}`}
                      text={obj.content && obj.content.length && obj.content}
                    />
                    <HeadLines
                      className={`positionAbsolute margin-top16 font-size14 line-height16 font-weight500 letterSpacing025 text-underline colorAccent3 cursor-pointer ${style["bottom16"]}`}
                      text={"Read More"}
                      onClick={() => handleReadMore(obj.extra_data.pdf)}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      {/* {cardData.map((item) => {
        return (
          <MediaCoverageCard
            detailsClassName="padding-bottom12"
            headingClassName={`${style["margin-bottom6"]}`}
            subHeadingClassName={`${style["margin-bottom14"]}`}
            imageClassName={style["news-img-style"]}
            shortCard={true}
            imgSrc={item.multimedia.file_name}
            blackStripText={item.subtitle}
            headingText={item.title}
            subHeadingText={item.content}
            pageUrl={item.extra_data.pdf}
          />
        );
      })} */}
    </div>
  );
};
export default NewsCard;
